import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { ErrorService } from '../errors/error.service';

@Injectable({
  providedIn: 'root'
})
export class ProviderTypeService {

  private readonly PROVIDER_SERVICE_URL = '/dpwsvc/v1/ext/code/';
  private readonly PROVIDER_CODE: string = 'PROVIDER_TYPE';

  private _provider: Map<string, string>;

  constructor(private http: HttpClient, private environmentService: EnvironmentService, private errorService: ErrorService) {
  }

  public getProvider() {
    this.http.get<Map<string, string>>(this.environmentService.getServer() +
                                      this.PROVIDER_SERVICE_URL +
                                      this.PROVIDER_CODE).subscribe(res => {
      this._provider = res;
    }, error => {
      this.errorService.processError(error);
    });
  }

  public get provider(): Map<string, string> {
    return this._provider;
  }
}
